<template>
  <div id="commonLoading">
    <el-dialog :visible.sync="showCommonLoader" width="30%" center>
      <p style="text-align: center; margin-bottom: 20px;">如遇运行缓慢 请切换其他线路</p>
      <p style="padding: 20px 0px" v-loading="loading"></p>
      <div>
        <p style="text-align: center">下载中</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "commonLoading",
  components: {},
  data() {
    return {
      showCommonLoader: false,
      loading: true,
    };
  },
  mounted: function () {},
  methods: {
    showCommonLoadigIcon() {
      this.showCommonLoader = true;
    },
    hideCommonLoadigIcon() {
      this.showCommonLoader = false;
    },
  },
};
</script>
<style>
#commonLoading .el-dialog__headerbtn .el-dialog__close {
  display: none;
}

#commonLoading .el-loading-spinner .circular {
  width: 120px;
  height: 120px;
}

#commonLoading .el-dialog__header {
  display: none;
}

#commonLoading .el-dialog--center {
  height: 27%;
  border-radius: 15px;
}

#commonLoading .el-loading-mask{
    position: relative;
}

#commonLoading .el-loading-spinner{
    position: relative;
}

#commonLoading .el-loading-spinner .path {
    stroke: #606266;
}
</style>





// WEBPACK FOOTER //
// src/components/common/commonLoading.vue